import React, { useState, useEffect } from 'react';
import './SessionNamingStep.css';

/**
 * Session naming step in the new session flow.
 * Shows template info and allows user to name the session.
 */
function SessionNamingStep({ template, onBack, onSubmit, isLoading }) {
  const [name, setName] = useState('');

  // Pre-fill with template's name prefix when template changes
  useEffect(() => {
    if (template?.name_prefix) {
      setName(template.name_prefix);
    } else {
      setName('');
    }
  }, [template]);

  const handleSubmit = (e) => {
    e?.preventDefault();
    const finalName = name.trim() || 'Untitled Session';
    onSubmit(finalName);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !isLoading) {
      e.preventDefault();
      handleSubmit();
    }
  };

  if (isLoading) {
    return (
      <div className="session-naming session-naming--loading">
        <div className="session-naming__spinner" />
        <p className="session-naming__loading-text">Creating session...</p>
        <p className="session-naming__loading-subtext">
          Your AI collaborator is preparing to dive in.
        </p>
      </div>
    );
  }

  if (!template) {
    return null;
  }

  return (
    <div className="session-naming">
      <div className="session-naming__header">
        <span className="session-naming__icon">{template.icon}</span>
        <h2 className="session-naming__title">{template.name}</h2>
      </div>

      <form onSubmit={handleSubmit} className="session-naming__form">
        <label className="session-naming__label">
          Session name
          <input
            type="text"
            className="session-naming__input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Untitled Session"
            autoFocus
          />
        </label>

        <p className="session-naming__description">{template.long_description}</p>

        <div className="session-naming__actions">
          <button
            type="button"
            className="session-naming__btn session-naming__btn--back"
            onClick={onBack}
          >
            Back
          </button>
          <button
            type="submit"
            className="session-naming__btn session-naming__btn--submit"
          >
            Start Session
          </button>
        </div>
      </form>
    </div>
  );
}

export default SessionNamingStep;
